import { SEARCH } from "../../../assets/js/constants";

const SELECTORS = {
  list: "SearchResults-list",
  listItem: "SearchResults-listItem",
  resultLink: "SearchResults-resultLink",
  showMore: "SearchResults-showMore",
  datasets: {
    url: "resultsUrl",
    category: "resultsCategory",
  },
  utils: {
    hidden: "u-hidden",
  },
};

/**
 * This class handles the searchResults dropdown by
 * cloning a template element to add it to the list if
 * results are provided
 */
class SearchResults {
  /**
   *
   * @param {HTMLElement} searchResults
   */
  constructor(searchResults) {
    this.searchResults = searchResults;
    this.resultsMaxLength = SEARCH.resultsMaxLength;

    this._initializeSearchResults();
  }

  /**
   * Query all necessary elements
   */
  _initializeSearchResults() {
    this.list = this.searchResults.querySelector(`.${SELECTORS.list}`);
    this.template = this.searchResults.querySelector("template");
    this.showMoreButton = this.searchResults.querySelector(
      `.${SELECTORS.showMore}`
    );
    this.resultsUrl = this.showMoreButton.dataset[SELECTORS.datasets.url];
    this.resultsCategory =
      this.showMoreButton.dataset[SELECTORS.datasets.category];
  }

  /**
   * Check if results are legit and show or hide
   * the results dropdown
   *
   * @param {*} results
   */
  handleResults(results) {
    this._cleanResultsFromList();
    if (Array.isArray(results) && results.length) {
      this._showResults(results);
    } else {
      this._hideResults();
    }
  }

  /**
   * Update the ShowMoreButton url with params and search string
   *
   * @param {string} searchString
   */
  updateShowMoreButton(searchString) {
    const url = `${this.resultsUrl}?search=${searchString}&category=${this.resultsCategory}`;
    this.showMoreButton.href = url;
  }

  /**
   * This shows the dropdown and add the results
   * as a list to it
   *
   * @param {Array} results
   */
  _showResults(results) {
    this._addResultsToList(results);
    this.searchResults.classList.remove(SELECTORS.utils.hidden);
  }

  /**
   * This hides the results
   */
  _hideResults() {
    this.searchResults.classList.add(SELECTORS.utils.hidden);
  }

  /**
   * Clean up the results list
   */
  _cleanResultsFromList() {
    while (this.list.hasChildNodes()) {
      this.list.removeChild(this.list.lastChild);
    }
  }

  /**
   * Slice the results array to resultsMaxLength and add
   * the results to the list by cloning the template element
   *
   * @param {Array} results
   */
  _addResultsToList(results) {
    results.slice(0, this.resultsMaxLength).forEach((result) => {
      const clone = this.template.content.cloneNode(true);
      const listItem = clone.querySelector(`.${SELECTORS.listItem}`);
      const resultLink = listItem.querySelector(`.${SELECTORS.resultLink}`);
      resultLink.href = result.url;
      resultLink.innerText = result.label;
      this.list.appendChild(listItem);
    });
  }
}

export default SearchResults;
